import * as actionTypes from '../actions/actionTypes';

const initialState = {
    message: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.GET_MESSAGE_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case actionTypes.GET_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: null
            };
        case actionTypes.GET_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: action.payload.message
            };
        default:
            return state;
    }
};

export default reducer;